import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import StaffSelector from '../../../../StaffSelector'

const OnsiteTeamLeader = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <StaffSelector
        value={opsPlan?.onsiteTeamLeader ?? null}
        onChange={(e, value) => {
          setOpsPlan((prev) => ({
            ...prev,
            onsiteTeamLeader: value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        label="Onsite Team Leader"
        shrinkLabel={!!opsPlan?.onsiteTeamLeader}
      />
    </Grid>
  )
}

export default React.memo(OnsiteTeamLeader)
